/* import __COLOCATED_TEMPLATE__ from './campaign-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    bannerText: string;
    bannerCtaText?: string;
    onCtaClick?: () => void;
  };
}

const CampaignBanner = templateOnlyComponent<Signature>();
export default CampaignBanner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Banners::CampaignBanner': typeof CampaignBanner;
    'banners/campaign-banner': typeof CampaignBanner;
  }
}
